<!-- https://www.figma.com/file/hZ14djvbx5qYuIJwSU7moW/%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B-%F0%9F%94%A5?node-id=5%3A1125 -->
<template>
  <div class="ads-page-useful-info">
    <div class="ads-page-useful-info__title">{{ title }}</div>

    <div class="ads-page-useful-info__list">
      <ArticleCardSmallList
        :articles="articles"
        @article-click="sendArticleAnalytics"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  // @ts-expect-error throttle-debounce types mismatch with current TS config
  import { throttle } from 'throttle-debounce';
  import type { IContentAdsPageContactsList } from '~/types/components/AdsPageUsefulInfo';
  import ArticleCardSmallList from '~/components/ArticleCardSmallList.vue';
  import type { TArticle } from '~/types/common';
  import { getContentObject, percentageInit, viewedContentPercent } from '~/utils/percentagePage';

  const scrollingElementSelector = '.ads-page-useful-info';

  export default defineNuxtComponent({
    name: 'AdsPageUsefulInfo',

    components: {
      ArticleCardSmallList,
    },

    provide() {
      return {
        articleCardSmallType: () => 'light',
        eventCategory: () => 'Страница рекламы',
        eventName: () => 'Страница рекламы_спецпроекты',
      };
    },

    props: {
      elem: {
        type: Object as PropType<IContentAdsPageContactsList>,
        required: true,
      },
    },

    computed: {
      articles(): TArticle[] {
        return this.elem.attributes.posts;
      },

      title(): string {
        return this.elem.attributes.text;
      },

      throttledScroll(): () => void {
        return throttle(100, this.onScroll);
      },
    },

    mounted() {
      percentageInit(scrollingElementSelector);
      window.addEventListener('scroll', this.throttledScroll, { passive: true });
    },

    beforeUnmount() {
      window.removeEventListener('scroll', this.throttledScroll);
    },

    methods: {
      onScroll(): void {
        const contentPercent = viewedContentPercent(scrollingElementSelector);

        if (contentPercent) {
          this.percentageSendAnalytics(getContentObject(scrollingElementSelector), contentPercent);
        }
      },

      percentageSendAnalytics(typeCategory: any, newValue: any) {
        const { thresholds } = typeCategory;

        const viewedThresholds = Object.keys(thresholds).filter(
          (threshold) => threshold <= newValue && !thresholds[threshold],
        );

        viewedThresholds.forEach((threshold) => {
          thresholds[threshold] = true;

          this.$sendYandexMetrika({
            level1: 'Прокрутка_рекомендательный блок',
            level4: threshold,
          });
        });
      },

      sendArticleAnalytics(article: TArticle, articleIndex: number) {
        this.$sendYandexMetrika({
          level1: 'Выбор материала_рекомендательный блок',
          level4: article.url,
          level5: articleIndex + 1,
        });
      },
    },
  });
</script>

<style lang="scss" scoped>
  .ads-page-useful-info {
    margin-top: 48px !important;
    margin-left: -16px;
    margin-right: -16px;

    @include tablet {
      margin-top: 60px !important;
      margin-left: -28px;
      margin-right: -28px;
    }

    @include desktop {
      margin-left: -32px;
      margin-right: -32px;
    }

    &__title {
      font-family: $headline-font--1;
      @include headline-normal-text;
      margin-left: 16px;
      margin-right: 16px;
      margin-bottom: 16px;

      @include tablet {
        @include headline-big-text;
        margin-left: 24px;
        margin-right: 24px;
      }
    }

    &__list {
      @include big-tablet {
        margin-left: -8px;
      }

      @include desktop {
        margin-left: -16px;
      }
    }
  }
</style>
